import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2z"
}), 'BookmarkOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BookmarkOutlined.js
// module id = 2399
// module chunks = 2